import EmblaCarousel from 'embla-carousel'
import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: { clickPager: 'clickPager' } }
  }

  init() {
    this.progressBar = this.el.querySelector('.news-slider__bar__progress')
    this.counterEl = this.el.querySelector('.news-slider__counter')
    this.counterIndexEl = this.el.querySelector('.news-slider__counter__current')
    this.pagers = [...this.el.querySelectorAll('.images-block__pager')]
    this.barEl = this.el.querySelector('.news-slider__bar')
    this.quickSetterProgressBar = gsap.quickSetter(this.progressBar, 'scaleX')
    this.quickSetterCounter = gsap.quickSetter(
      this.counterEl,
      'x',
      'px'
    )

    this.ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this.barEl) {
          this.barWidth = entry.contentRect.width
        }
        if (entry.target === this.counterEl) {
          this.counterWidth = entry.contentRect.width
        }
      }
    })

    this.ro.observe(this.barEl)
    this.ro.observe(this.counterEl)

    const viewportNode = this.el.querySelector('.embla__viewport')

    this.emblaApi = EmblaCarousel(viewportNode, {
      align: 'center',
      dragFree: false,
      breakpoints: { '(width > 700px)': {
        dragFree: true,
        align: 'start'
      } }
    })

    this.currentSlide = 0
    this.numberOfSlides = this.emblaApi.slideNodes().length

    this.emblaApi.on('scroll', (e) => {
      const progress = e.scrollProgress()
      const clampedProgress = Math.max(0, Math.min(1, progress))

      this.quickSetterProgressBar(clampedProgress)
      this.quickSetterCounter(clampedProgress * (this.barWidth - this.counterWidth))
    })

    this.emblaApi.on('select', () => {
      const currentSlide = this.emblaApi.selectedScrollSnap()

      if (currentSlide !== this.currentSlide) {
        this.counterIndexEl.textContent = String(currentSlide + 1).padStart(2, '0')

        for (let i = 0; i < this.pagers.length; i++) {
          this.pagers[i].classList.remove('active')
        }

        this.pagers[currentSlide].classList.add('active')

        this.currentSlide = currentSlide
      }
    })
  }

  clickPager(e) {
    if (!e.currentTarget.classList.contains('active')) {
      this.emblaApi.scrollTo(this.pagers.indexOf(e.currentTarget))
    }
  }

  destroy() {
    this.ro.disconnect()
    this.emblaApi.destroy()
  }
}
